export default __webpack_public_path__ + "static/media/down.b074ce05.svg";